import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const SUPPORTED_LANGUAGES = ['en', 'ru', 'ar'];
const RTL_LANGUAGES = ['ar'];

function getInitialLanguage() {
  try {
    const stored = localStorage.getItem('app_language');
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
      return stored;
    }
  } catch {
    // ignore
  }
  return 'en';
}

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Locale URLs are stable across releases; revalidate even an old cached response.
      requestOptions: { cache: 'no-cache' },
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);

  try {
    localStorage.setItem('app_language', lng);
  } catch {
    // ignore
  }

  const link = document.getElementById('app-materialpro-css');
  if (link) {
    link.href = dir === 'rtl' ? '/assets/css/styles-rtl.css' : '/assets/css/styles.css';
  }
});

// Apply initial direction
const initialLng = i18n.language;
const initialDir = RTL_LANGUAGES.includes(initialLng) ? 'rtl' : 'ltr';
document.documentElement.setAttribute('dir', initialDir);
document.documentElement.setAttribute('lang', initialLng);

export { SUPPORTED_LANGUAGES, RTL_LANGUAGES };
export default i18n;
